import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from '../../services/user.service';
import { PopupEndPoint } from '../../../modules/inspection/models/create-inspection.model';
import { AddCommentModalComponent } from './add-comment-modal/add-comment-modal-component';

@Component({
  selector: 'app-comment-component',
  templateUrl: './comment-component.html',
  styleUrls: ['./comment-component.scss']
})

export class CommentComponentComponent implements OnInit {
  @Input() inspectionId: number;
  @Input() comment = '';
  @Input() ScreenId: number;
  @Input() endPoint: PopupEndPoint;
  @Input() equipmentId: number;
  @Output() commentUpdated = new EventEmitter<any>();
  @Output() SystemPhotoUpload:EventEmitter<any> = new EventEmitter();
  isInspector = false;
  isInterpreter = false;

  constructor(
    //private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _dialog: MatDialog,
    private _user: UserService,) { }

  ngOnInit() {
    this.checkPermissions();
    console.log('EqBarComment:', this.comment);
  }

  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case 'Inspectors':
              this.isInspector = true;
              break;
            case 'Interpreters':
            case 'Super User':
            case 'Administrator':
              this.isInterpreter = true;
              this.isInspector = true;
              break;
              case 'Customer Admin':
                this.isInspector = true;
              this.isInterpreter = true;
                break;
                case 'Undercarriage ONLY':
                case 'Undercarriage Inspector ONLY':
                 this.isInspector = true;
                break;
          }
        });
      },
      error => {
        console.error(error);
        this._notify.error('Error', 'Unable to check your job roles. ');
      }
    );
  }

  viewComponentComment() {
    var passingData;
    if (this.endPoint) {
      passingData = {
        inspectionId: this.inspectionId,
        comment: this.comment,
        comingFrom: this.endPoint,
        equipmentId: this.equipmentId,
        showplus:false,
      };
    }
    const viewCommentModalRef = this._dialog.open(AddCommentModalComponent, {
      width: '1032px',
      data: passingData,
    });
    viewCommentModalRef.afterClosed().subscribe(result => {
      if (result){
        this.comment = result.comment;
        this.commentUpdated.emit(result);
      }
    });
  }
}
